import { Select, createListCollection } from '@chakra-ui/react';
import ApplicationErrorView from '@packages/charka-common-ui/graphql/error/application-error-view';
import { naturalCompare } from '@packages/charka-common-ui/utils/natural-compare';
import { useTranslate } from '@tolgee/react';
import { useParams } from 'react-router-dom';
import { useMenuSection } from '../logic/use-menu-section';

export default function SectionMultipleSelect(props: {
  allowedSections: string[];
  onChange: (allowedSectionIds: string[]) => void;
}) {
  const menuId = useParams().menuId ?? '';
  const { data, error, loading } = useMenuSection(menuId);
  const { t } = useTranslate();

  if (loading) {
    return null;
  }

  const sortedMenuSections = data?.menuSections.sort((a, b) => naturalCompare(a.code, b.code));

  const sectionData = createListCollection({
    items:
      sortedMenuSections?.map((section) => ({
        label: section.name,
        value: section.id,
      })) ?? [],
  });

  return (
    <>
      <ApplicationErrorView error={error} />
      <Select.Root
        defaultValue={props.allowedSections}
        onValueChange={({ value }) => {
          props.onChange(value);
        }}
        multiple
        border={'solid 1px'}
        collection={sectionData}
        size="sm"
        py={1}
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText px={2} placeholder={t('page-rule.sections.placeholder', 'Select categories')} />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            {sectionData.items.map((framework) => (
              <Select.Item zIndex={50} item={framework} key={framework.value}>
                {framework.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </>
  );
}
